import React, { useEffect, useState } from "react";
import api from "../utils/axios";
import { useAuth } from "../contexts/AuthContext";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";

// Fix Leaflet marker icon (important!)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export default function VehicleMap() {
  const [vehicles, setVehicles] = useState([]);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return;
    
    api
      .get("/api/vehicles/")
      .then((res) => setVehicles(res.data))
              .catch((err) => {
          // Handle error silently
        });
  }, [isAuthenticated]);

  return (
    <div>
      <h2>Vehicle Locations</h2>
      <MapContainer
        center={[3.139, 101.6869]} // Kuala Lumpur default
        zoom={12}
        style={{ height: "500px", width: "100%" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
        />

        {vehicles
          .filter((v) => v.latitude && v.longitude)
          .map((v) => (
            <Marker key={v.id} position={[v.latitude, v.longitude]}>
              <Popup>
                <strong>{v.name}</strong><br />
                Plate: {v.license_plate}<br />
                Status: {v.status}
              </Popup>
            </Marker>
          ))}
      </MapContainer>
    </div>
  );
}
